export default {
  name: 'dropdown',
  component_path: 'modules/procedures/blocks/BlockInputSelect'
}